import {
  FieldErrors,
  FieldValues,
  FormState,
  UseFormGetValues,
} from 'react-hook-form';

export function useDirtyFieldClass<T extends FieldValues>(
  dirtyFields: FormState<T>['dirtyFields'],
  errors: FieldErrors<T>,
  getValues: UseFormGetValues<T>
) {
  const getDirtyClass = (field: keyof T): string => {
    const fieldKey = field as string;
    const dirtyFieldsObj = dirtyFields as Record<string, boolean | undefined>;
    return dirtyFieldsObj[fieldKey] && !errors[field]
      ? 'bg-info-subtle border-info'
      : '';
  };

  const isDirty = Object.keys(dirtyFields).length > 0;

  const getChangedFields = (): Partial<T> => {
    const values = getValues();
    return Object.fromEntries(
      Object.keys(dirtyFields).map((key) => [key, values[key as keyof T]])
    ) as Partial<T>;
  };

  const isFieldDirty = (field: keyof T): boolean => {
    const fieldKey = field as string;
    const dirtyFieldsObj = dirtyFields as Record<string, boolean | undefined>;
    return !!dirtyFieldsObj[fieldKey];
  };

  return {
    getDirtyClass,
    isDirty,
    getChangedFields,
    isFieldDirty,
  };
}
